module.exports = __webpack_public_path__ + "img/close1.5c424f2f.png";